"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuItem;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./../PrimitiveMenu/context");

var _icon = _interopRequireDefault(require("./icon"));

var _header = _interopRequireDefault(require("./styled/header"));

var _headerLabel = _interopRequireDefault(require("./styled/headerLabel"));

var _li = _interopRequireDefault(require("./styled/li"));

var _iconContainer = _interopRequireDefault(require("./styled/iconContainer"));

/* eslint-disable no-script-url, react/prop-types */
var Item =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Item, _Component);

  function Item(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Item);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Item).call(this, props));
    _this.itemRef = _react["default"].createRef();
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleHover = _this.handleHover.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          privateRegisterChild = _this$props.privateRegisterChild,
          disabled = _this$props.disabled,
          variant = _this$props.variant;
      var isHeader = variant === 'header';

      if (disabled || isHeader) {
        return null;
      }

      return setTimeout(function () {
        return privateRegisterChild(_this2.itemRef.current);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var privateUnregisterChild = this.props.privateUnregisterChild;
      return privateUnregisterChild(this.itemRef.current);
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick,
          privateOnClose = _this$props2.privateOnClose;

      if (disabled) {
        return null;
      }

      onClick(event);
      return privateOnClose();
    }
  }, {
    key: "handleHover",
    value: function handleHover(event) {
      var _this$props3 = this.props,
          privateOnHover = _this$props3.privateOnHover,
          disabled = _this$props3.disabled;

      if (disabled) {
        return null;
      }

      return privateOnHover(event, this.itemRef.current);
    }
  }, {
    key: "click",
    value: function click() {
      this.itemRef.current.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          style = _this$props4.style,
          className = _this$props4.className,
          label = _this$props4.label,
          title = _this$props4.title,
          variant = _this$props4.variant,
          icon = _this$props4.icon,
          iconPosition = _this$props4.iconPosition,
          disabled = _this$props4.disabled;

      if (variant === 'header') {
        return _react["default"].createElement(_header["default"], {
          className: className,
          style: style,
          title: title,
          role: "separator"
        }, _react["default"].createElement(_headerLabel["default"], null, label));
      }

      var hasLeftIcon = !!(icon && iconPosition === 'left');
      var hasRightIcon = !!(icon && iconPosition === 'right');
      return _react["default"].createElement(_li["default"], {
        className: className,
        style: style,
        role: "menuitem",
        onClick: this.handleClick,
        onMouseEnter: this.handleHover,
        "aria-disabled": disabled,
        tabIndex: "-1",
        ref: this.itemRef
      }, _react["default"].createElement(_iconContainer["default"], {
        title: title
      }, _react["default"].createElement(_icon["default"], {
        "data-id": "menu-item-left-icon",
        icon: icon,
        isVisible: hasLeftIcon,
        position: iconPosition
      }), label), _react["default"].createElement(_icon["default"], {
        "data-id": "menu-item-right-icon",
        icon: icon,
        isVisible: hasRightIcon,
        position: iconPosition
      }));
    }
  }]);
  return Item;
}(_react.Component);
/**
 * Represents a list item in a menu.
 */


function MenuItem(props) {
  return _react["default"].createElement(_context.Consumer, null, function (values) {
    return _react["default"].createElement(Item, (0, _extends2["default"])({}, props, values));
  });
}

MenuItem.propTypes = {
  /** Text of the menu item. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The variant changes the type of menu item. Accepted variants include default and header.
   * This value defaults to default. */
  variant: _propTypes["default"].oneOf(['default', 'header']),

  /** The icon to show if it is passed. It must be a svg icon or a font icon. */
  icon: _propTypes["default"].node,

  /** Describes the position of the icon with respect to body. Options include left and right.
   * This value defaults to left. */
  iconPosition: _propTypes["default"].oneOf(['left', 'right']),

  /** If true the menu item is not actionable and is shown as disabled. */
  disabled: _propTypes["default"].bool,

  /** The action triggered when the menu item is clicked. */
  onClick: _propTypes["default"].func,

  /** Displays tooltip text when the mouse moves over the element. */
  title: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
MenuItem.defaultProps = {
  label: null,
  variant: 'default',
  icon: null,
  iconPosition: 'left',
  disabled: false,
  onClick: function onClick() {},
  title: undefined,
  className: undefined,
  style: undefined
};